import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { paymentStatus } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let mounted = true;
    let n = 0;
    const poll = async () => {
      if (!mounted) return;
      try {
        const s = await paymentStatus(sid);
        setStatus(s); n++; setAttempts(n);
        if (s.payment_status === "paid" || s.payment_status === "expired" || n > 20) return;
      } catch { n++; setAttempts(n); }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { mounted = false; };
  }, [sid]);

  const paid = status.payment_status === "paid";
  const meta = status.metadata || {};

  return (
    <div className="pt-24 min-h-screen" data-testid="payment-success-page">
      <div className="max-w-md mx-auto px-6 py-12 text-center">
        {paid ? (
          <>
            <div className="w-20 h-20 rounded-full bg-[#D4AF37]/20 border-2 border-[#D4AF37] flex items-center justify-center mx-auto mb-6"><CheckCircle2 className="w-10 h-10 text-[#D4AF37]"/></div>
            <h1 className="font-heading text-4xl font-bold mb-3" data-testid="payment-paid-header">Thank You!</h1>
            <p className="text-white/70 mb-8">Your payment was successful.</p>
            {meta.kind === "book" && <Link to="/books" className="btn-gold px-6 py-3 rounded-full text-sm font-semibold inline-block">Access your book →</Link>}
            {meta.kind === "ad" && <Link to="/advertise" className="btn-gold px-6 py-3 rounded-full text-sm font-semibold inline-block">View your ads →</Link>}
            {!meta.kind && <Link to="/" className="btn-gold px-6 py-3 rounded-full text-sm font-semibold inline-block">Back to home →</Link>}
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 text-[#D4AF37] mx-auto animate-spin mb-4" />
            <h1 className="font-heading text-3xl font-bold mb-3">Confirming payment…</h1>
            <p className="text-white/60 text-sm">This typically takes 2-5 seconds. (Poll {attempts})</p>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="pt-24 min-h-screen" data-testid="payment-cancel-page">
      <div className="max-w-md mx-auto px-6 py-12 text-center">
        <div className="w-20 h-20 rounded-full bg-white/10 border border-white/20 flex items-center justify-center mx-auto mb-6"><XCircle className="w-10 h-10 text-white/60"/></div>
        <h1 className="font-heading text-4xl font-bold mb-3">Payment Cancelled</h1>
        <p className="text-white/70 mb-8">No charge was made.</p>
        <Link to="/" className="btn-ghost px-6 py-3 rounded-full text-sm font-semibold inline-block">Back to home</Link>
      </div>
    </div>
  );
}
